import styled from 'styled-components'

export const LoadingWrapper = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: grey;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.5);
`
